export class RegistroCadastro {
  idCampo: number;
  idIdentificadorCadastro: number;
  valor: string;
}